<formItem
  type="checkbox"
  label="{{ 'button.add_to_comparison' | translate }}"
  [(ngModel)]="checked"
  (onChange)="compareChange(id, $event);"
  [testId]="'compare-item-checkbox-' + id">
</formItem>